import { useNavigate } from "react-router-dom"
import { Container } from "../../../components/Container"
import { Section } from "../../../components/Section"
import { Steps } from "../../../components/Steps"
import { StepsContent } from "../../../context/StepsContext"
import { Step4Form } from '../../../containers/cestovko/Step4Form'
import { InsuranceInfo } from "../../../containers/InsuranceInfo"
import { AxiosError } from "axios"
import { insuranceParamsContext } from "../../../layouts/Wizard"
import { useContext } from "react"
import { useUpdateLastWizardStep, useSaveStep4 } from "../../../hooks/useWizard"
import { WizardTravelAdditionalData } from "BrokerTsLib/src/dtos"
import { WithAuth } from "../../../containers/hoc/WithAuth"
import WizardForbiddenMessage from "../../../components/WizardForbiddenMessage"

const _Step4 = () => {
  const navigate = useNavigate()

  const { insuranceParams, insuranceParamsId, refetchInsuranceParams } = useContext(insuranceParamsContext)
  const { mutateAsync: saveStep4 } = useSaveStep4()
  const { mutateAsync: updateStep } = useUpdateLastWizardStep()

  const handleSubmit = (values: WizardTravelAdditionalData) => {
    return new Promise((resolve, reject) =>
      saveStep4(values)
        .then((response) => {
          if (values.nextPage == 'next') {
            if ((insuranceParams?.generalParams.lastWizardStep ?? 4) < 5) {
              updateStep({ paramsId: Number(insuranceParamsId), step: 5 }).then(() => refetchInsuranceParams())
            }
            else {
              refetchInsuranceParams()
            }

            navigate(`/cestovko/wizard/5/${insuranceParamsId}`)
          } else {
            refetchInsuranceParams()
            window.scrollTo(0, 0)
          }

          resolve(response)
        })
        .catch((err: AxiosError) => {
          reject(err)
        })
        .finally(() => { }))
  }


  return (
    <Section>
      <Container>
        <StepsContent step={4}>
          <Steps icon="beach" />

          <InsuranceInfo />

          <Step4Form onSubmit={handleSubmit} />
        </StepsContent>

        <WizardForbiddenMessage />
      </Container>
    </Section>
  )
}

export const Step4 = WithAuth(_Step4)